"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = require("debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const string_1 = require("../../../common/js/helper/string");
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const _variables_scss_1 = __importDefault(require("../../../scss/_variables.scss"));
const ProductSuggestionDropdown_1 = __importDefault(require("../../atoms/ProductSuggestionDropdown"));
const Paths_1 = require("../../constants/Paths");
const CartErrors_1 = __importDefault(require("../../enums/CartErrors"));
const DataLayerEvents_1 = __importDefault(require("../../enums/DataLayerEvents"));
const DataLayerLabels_1 = __importDefault(require("../../enums/DataLayerLabels"));
const dataLayer_1 = require("../../helper/dataLayer");
const dropdown_1 = require("../../helper/dropdown");
const money_1 = require("../../helper/money");
const path_1 = require("../../helper/path");
const product_1 = require("../../helper/product");
const ShopwareCart_1 = __importDefault(require("../../stores/ShopwareCart"));
const ShopwareContext_1 = __importDefault(require("../../stores/ShopwareContext"));
const ShopwareProducts_1 = __importDefault(require("../../stores/ShopwareProducts"));
const CartListItem_1 = __importDefault(require("../CartListItem"));
const VoucherInput_1 = __importDefault(require("../shop/VoucherInput"));
class ShopCartPage extends react_1.default.Component {
    debouncedSearchInputChanged = (0, debounce_1.debounce)(this.onSearchChange, 500);
    quickOrderRef = react_1.default.createRef();
    quickOrderInputRef = react_1.default.createRef();
    cartAccessReactionDisposer;
    initialLoading = true;
    isLoading = false;
    isSuggestionLoading = false;
    suggestionIconName = '';
    searchValue = '';
    suggestedProducts;
    showProductSuggestions = false;
    isDesktopView = false;
    isDesktopViewMediaQuery = window.matchMedia(`(min-width: ${_variables_scss_1.default.breakpoint_lg})`);
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            initialLoading: mobx_1.observable,
            isLoading: mobx_1.observable,
            isSuggestionLoading: mobx_1.observable,
            suggestionIconName: mobx_1.observable,
            searchValue: mobx_1.observable,
            suggestedProducts: mobx_1.observable,
            showProductSuggestions: mobx_1.observable,
            isDesktopView: mobx_1.observable,
            productLineItems: mobx_1.computed,
            surchargeLineItems: mobx_1.computed,
            promotionLineItems: mobx_1.computed,
            currency: mobx_1.computed,
            showVoucherInput: mobx_1.computed,
            onShowProductSuggestions: mobx_1.action.bound,
            onSearchChange: mobx_1.action.bound,
            onSearchClear: mobx_1.action.bound,
            onDesktopViewMediaChange: mobx_1.action.bound,
        });
    }
    get productLineItems() {
        return ShopwareCart_1.default.cart?.lineItems?.filter((lineItem) => lineItem.type === ecommerce_1.LineItemTypeEnum.Product) ?? [];
    }
    get surchargeLineItems() {
        return ShopwareCart_1.default.cart?.lineItems?.filter((lineItem) => lineItem.type === ecommerce_1.LineItemTypeEnum.Surcharge) ?? [];
    }
    get promotionLineItems() {
        return ShopwareCart_1.default.cart?.lineItems?.filter((lineItem) => lineItem.type === ecommerce_1.LineItemTypeEnum.Promotion) ?? [];
    }
    get currency() {
        return ShopwareContext_1.default.currency?.isoCode ?? null;
    }
    get showVoucherInput() {
        return (ShopwareCart_1.default.cartGroups?.products?.length ?? 0) > 0;
    }
    componentDidMount() {
        document.addEventListener('click', this.onShowProductSuggestions);
        window.addEventListener('resize', this.onWindowResize);
        document.title = (0, translation_1.t)('shop_subpage_title', { title: (0, translation_1.t)('cart.page_title') });
        (0, dataLayer_1.pushToDataLayerNavigation)({
            [DataLayerLabels_1.default.dlvNavigationLevelOne]: (0, translation_1.t)('navigation.shop.title'),
            [DataLayerLabels_1.default.dlvNavigationLevelTwo]: (0, translation_1.t)('cart.page_title'),
        });
        this.cartAccessReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => {
            this.initialLoading = true;
            ShopwareCart_1.default.reset();
            ShopwareCart_1.default.loadCart().finally((0, mobx_1.action)(() => {
                this.initialLoading = false;
            }));
        }, { fireImmediately: true });
        this.isDesktopView = this.isDesktopViewMediaQuery.matches;
        this.isDesktopViewMediaQuery.addEventListener('change', this.onDesktopViewMediaChange);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onShowProductSuggestions);
        this.cartAccessReactionDisposer?.();
        this.isDesktopViewMediaQuery.removeEventListener('change', this.onDesktopViewMediaChange);
    }
    render() {
        const defer = ShopwareCart_1.default.cartErrors.find((error) => error.messageKey === CartErrors_1.default.deferredProductPrice);
        return (react_1.default.createElement("section", { className: "znd-shop-cart-page" },
            react_1.default.createElement("div", { className: "znd-shop-cart-page__title t-headline-2" }, (0, translation_1.t)('cart.title')),
            react_1.default.createElement("div", { className: "znd-shop-cart-page__subtitle" }, (0, translation_1.t)('cart.count', {
                itemsCount: ShopwareCart_1.default.productsCount,
            })),
            react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list" },
                react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-shop-cart-page__items-list-wrapper', this.suggestedProducts?.elements &&
                        this.suggestedProducts?.elements?.length > 0 &&
                        this.showProductSuggestions
                        ? '--quick-order-is-focused'
                        : null) },
                    ShopwareCart_1.default.hasCart && this.productLineItems && !this.initialLoading ? (this.productLineItems.map((lineItem) => lineItem.referencedId && ShopwareProducts_1.default.getProduct(lineItem.referencedId) ? (react_1.default.createElement(CartListItem_1.default, { product: ShopwareProducts_1.default.getProduct(lineItem.referencedId), lineItem: lineItem, key: lineItem.referencedId, onDelete: (0, mobx_1.action)((id) => {
                            this.isLoading = true;
                            return ShopwareCart_1.default.removeLineItemFromCart(id).finally((0, mobx_1.action)(() => {
                                this.isLoading = false;
                            }));
                        }), onQuantityChange: (0, mobx_1.action)((id, quantity) => {
                            if (quantity === undefined) {
                                return Promise.resolve(null);
                            }
                            this.isLoading = true;
                            return ShopwareCart_1.default.updateLineItemOfCart(id, quantity).finally((0, mobx_1.action)(() => {
                                this.isLoading = false;
                            }));
                        }) })) : (react_1.default.createElement(LoadingSpinner_1.default, { className: "mr-auto ml-auto py-5", key: Math.random() })))) : (react_1.default.createElement(LoadingSpinner_1.default, { className: "mr-auto ml-auto py-5" })),
                    ShopwareCart_1.default.hasProductWithCategorySoftware ? null : (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.CART_UPDATE] },
                        react_1.default.createElement("div", { className: "znd-shop-cart-page__quick-order", ref: this.quickOrderRef },
                            react_1.default.createElement("div", { className: "t-subhead-1 mb-3" }, (0, translation_1.t)('cart.quick_order.head')),
                            react_1.default.createElement("div", { className: "znd-shop-cart-page__quick-order__input-wrapper" },
                                react_1.default.createElement("input", { ref: this.quickOrderInputRef, id: "znd-shop-cart-page__quick-order__input", className: (0, classnames_1.default)('form-control', 'znd-shop-cart-page__quick-order__input'), placeholder: (0, translation_1.t)('cart.quick_order.placeholder'), value: this.searchValue, onChange: (0, mobx_1.action)((event) => {
                                        this.searchValue = event.target.value;
                                        this.debouncedSearchInputChanged();
                                    }), onClick: (event) => {
                                        event.preventDefault();
                                    }, onFocus: (0, mobx_1.action)(() => {
                                        if (this.quickOrderRef.current) {
                                            this.quickOrderRef.current.scrollIntoView();
                                        }
                                        this.showProductSuggestions = true;
                                    }) }),
                                this.isSuggestionLoading ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "znd-loading-spinner--small znd-loading-spinner--position-absolute" })) : (react_1.default.createElement(react_1.default.Fragment, null, this.suggestionIconName !== '' ? (react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.check, className: 'znd-shop-cart-page__quick-order__icon' })) : null)),
                                react_1.default.createElement(ProductSuggestionDropdown_1.default, { showDropdown: this.showProductSuggestions, suggestedProducts: this.suggestedProducts, fullWidth: true, onClick: (0, mobx_1.action)((event, product) => {
                                        event.preventDefault();
                                        if (!product.id) {
                                            return;
                                        }
                                        this.isSuggestionLoading = true;
                                        ShopwareCart_1.default.addProduct(product.id, (0, product_1.getMinPurchase)(product)).finally((0, mobx_1.action)(() => {
                                            this.isSuggestionLoading = false;
                                            this.suggestionIconName = Zupicons_1.default.check;
                                            setTimeout((0, mobx_1.action)(() => {
                                                this.suggestionIconName = '';
                                            }), 1000);
                                            (0, dataLayer_1.pushToDataLayer)({
                                                event: DataLayerEvents_1.default.dlvEventAddQuickOrderToCart,
                                                [DataLayerLabels_1.default.dlvAddQuickOrderToCart]: `${product.productNumber} ${product.translated?.name}`,
                                            });
                                        }));
                                        this.onSearchClear();
                                    }) })))))),
                !defer && ShopwareCart_1.default.showPrices ? (react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal-values d-flex flex-column" },
                    react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal-discount-surcharge-wrapper-mobile" },
                        this.renderDiscountOrSurcharge(this.promotionLineItems),
                        this.renderDiscountOrSurcharge(this.surchargeLineItems)))) : null,
                react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer" },
                    !defer && ShopwareCart_1.default.showPrices ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal-values d-flex flex-column" },
                            this.isDesktopView && this.showVoucherInput ? (react_1.default.createElement(VoucherInput_1.default, { className: "ml-auto" })) : null,
                            react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal-discount-surcharge-wrapper" },
                                this.renderDiscountOrSurcharge(this.promotionLineItems),
                                this.renderDiscountOrSurcharge(this.surchargeLineItems)),
                            react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal d-flex flex-row" },
                                react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal__text text-nowrap" }, (0, translation_1.t)('cart.subtotal')),
                                react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal__price text-right" }, null !== this.currency
                                    ? (0, money_1.moneyFormat)(ShopwareCart_1.default.netPriceOnlyLineItems, this.currency)
                                    : null))),
                        react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal-exclude t-body-small" }, (0, translation_1.t)('cart.subtotal_excluding')),
                        ShopwareCart_1.default.isOrderOnAccountBlocked ? (react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__order-on-account-blocked-message t-body-small", dangerouslySetInnerHTML: {
                                __html: (0, translation_1.t)('cart.blocked', { channel: AuthorizationStore_1.default.channelId }),
                            } })) : null)) : null,
                    react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__buttons" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths_1.PATH_SHOP), className: (0, classnames_1.default)('d-lg-block', ShopwareCart_1.default.productsCount > 0 ? ' d-none' : '') },
                            react_1.default.createElement(Button_1.default, { className: "text-nowrap", variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('cart.back_to_shop') })),
                        ShopwareCart_1.default.productsCount > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "d-none d-lg-block" },
                                react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT) },
                                    react_1.default.createElement(Button_1.default, { className: "znd-shop-cart-page__items-list__footer__buttons__proceed d-none d-lg-block", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('cart.proceed_checkout_long'), loading: this.isLoading, disabled: ShopwareCart_1.default.isOrderOnAccountBlocked }))),
                            react_1.default.createElement("div", { className: (0, classnames_1.default)('d-sm-block', 'd-lg-none', {
                                    'd-none': ShopwareCart_1.default.isOrderOnAccountBlocked,
                                }) },
                                react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT) },
                                    react_1.default.createElement(Button_1.default, { className: "znd-shop-cart-page__items-list__footer__buttons__proceed d-block d-lg-none", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('cart.proceed_checkout_short'), loading: this.isLoading, disabled: ShopwareCart_1.default.isOrderOnAccountBlocked }))))) : null))),
            !this.isDesktopView && this.showVoucherInput ? (react_1.default.createElement("div", { className: "znd-shop-cart-page__voucher" },
                react_1.default.createElement(VoucherInput_1.default, null))) : null));
    }
    renderDiscountOrSurcharge(lineItems) {
        return (react_1.default.createElement(react_1.default.Fragment, null, ShopwareCart_1.default.hasCart && lineItems && !this.initialLoading ? (react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal-discount-surcharge" }, lineItems
            .filter((item) => (item.price?.totalPrice ?? 0) !== 0)
            .map((lineItem) => (react_1.default.createElement("div", { className: "d-flex flex-row justify-content-between justify-content-sm-start", key: lineItem.id },
            react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal-discount-surcharge__label" },
                lineItem.payload?.code
                    ? (0, translation_1.t)('cart.voucher_code', { code: (0, string_1.ellipsis)(lineItem.payload?.code, 20) })
                    : lineItem.label,
                this.isDeletableItem(lineItem) ? (react_1.default.createElement("button", { className: (0, classnames_1.default)('ml-1', 'znd-shop-cart-page__items-list__footer__subtotal-discount-surcharge__remove', {
                        'text-primary': !ShopwareCart_1.default.isLoading,
                        'text-muted': ShopwareCart_1.default.isLoading,
                    }), onClick: () => {
                        if (!lineItem.id || ShopwareCart_1.default.isLoading) {
                            return;
                        }
                        ShopwareCart_1.default.removeLineItemFromCart(lineItem.id);
                    } },
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.trash }))) : null),
            react_1.default.createElement("div", { className: "znd-shop-cart-page__items-list__footer__subtotal-discount-surcharge__price text-nowrap" },
                lineItem.price?.totalPrice && lineItem.price?.totalPrice < 0 ? '– ' : null,
                isNaN(Number(lineItem.price?.totalPrice)) || null === this.currency
                    ? lineItem.price?.totalPrice
                    : (0, money_1.moneyFormat)(Math.abs(Number(lineItem.price?.totalPrice)), this.currency))))))) : null));
    }
    isDeletableItem(lineItem) {
        if (lineItem.type !== ecommerce_1.LineItemTypeEnum.Promotion) {
            return false;
        }
        const code = lineItem.referencedId ?? null;
        return null !== code && '' !== code && '0' !== code;
    }
    onWindowResize() {
        if (this.quickOrderRef.current &&
            this.quickOrderInputRef.current &&
            document.activeElement &&
            this.quickOrderInputRef.current === document.activeElement) {
            this.quickOrderRef.current.scrollIntoView();
        }
    }
    onSearchChange() {
        if (!this.searchValue || this.searchValue.length < 2) {
            this.suggestedProducts = undefined;
            return;
        }
        (0, dataLayer_1.pushToDataLayer)({
            event: DataLayerEvents_1.default.dlvEventQuickOrder,
            [DataLayerLabels_1.default.dlvQuickOrder]: this.searchValue,
        });
        this.isSuggestionLoading = true;
        (0, dropdown_1.getProductSuggestions)(this.searchValue)
            .then((0, mobx_1.action)((products) => {
            this.suggestedProducts = products;
            this.showProductSuggestions = true;
        }))
            .finally((0, mobx_1.action)(() => (this.isSuggestionLoading = false)));
    }
    onSearchClear() {
        this.searchValue = '';
        this.showProductSuggestions = false;
        this.suggestedProducts = undefined;
    }
    onShowProductSuggestions(event) {
        if (event.defaultPrevented) {
            return;
        }
        this.showProductSuggestions = false;
    }
    onDesktopViewMediaChange(event) {
        this.isDesktopView = event.matches;
    }
}
__decorate([
    bind_decorator_1.default
], ShopCartPage.prototype, "isDeletableItem", null);
__decorate([
    bind_decorator_1.default
], ShopCartPage.prototype, "onWindowResize", null);
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.CART_READ })((0, mobx_react_1.observer)(ShopCartPage)));
